module.exports = __webpack_public_path__ + "img/736a35be67bc82415e58849e569e7965.png";